/** @jsx jsx */
import { Flex, Box, jsx } from 'theme-ui';
import ALogo from '~/assets/images/A-logo.svg';
import TextRing from '~/assets/images/Innercycle-Ring.svg';

const InnerCycle = ({ ...props }) => (
  <Box {...props}>
    <Flex
      sx={{
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        '& > svg': { fill: 'alizarinCrimson' },
      }}
    >
      <ALogo sx={{ width: '50%' }} />
      <TextRing
        sx={{
          position: 'absolute',
          left: '2px',
          top: 0,
          height: '100%',
          width: '100%',
          animation: 'rotating 30s linear infinite',
        }}
      />
    </Flex>
  </Box>
);

export default InnerCycle;
